import React, {useEffect, useState} from 'react'
import {useNavigate, useParams} from 'react-router-dom';
import {AlertError} from '../../components/bootstrap/AlertError';
import Loading from '../../components/general/Loading';
import {SubTemplate} from '../../components/general/SubTemplate';
import {getCandidatureByExternalId} from '../../rest/candidature';
import {handleError, isNotBusinessError} from '../../utils/handleError';
import {AddAdditionalDueDiligenceForm} from "../../components/candidature/AddAdditionalDueDiligenceForm";
import {CandidatureState} from "../../models/CandidatureState";
import {
    addAdditionalDueDiligence,
    addAdditionalDueDiligenceWithDocuments,
    getAdditionalDueDiligenceByCandidature
} from "../../rest/additionalDueDiligences";
import {Arrays} from "../../utils/Arrays";
import {createMultiPart} from "../../components/SyncMultipleUploadArea";


export function AdditionalDueDiligence() {

    const {candidatureExternalId} = useParams();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [additionalDueDiligence, setAdditionalDueDiligence] = useState(null);

    async function fetchData() {
        setLoading(true);

        try {
            const [
                {data: additionalDueDiligence}
            ] = await Promise.all([
                getAdditionalDueDiligenceByCandidature(candidatureExternalId),
            ]);
            setAdditionalDueDiligence(additionalDueDiligence);
        } catch (error) {
            setError(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    async function handleSubmit(newAdditionalDueDiligence, documents) {
        try {
            if(Arrays.isNotEmpty(documents)) {
                const formData = createMultiPart(documents);
                formData.append('AdditionalDueDiligenceDto', JSON.stringify(newAdditionalDueDiligence));
                await addAdditionalDueDiligenceWithDocuments(candidatureExternalId, formData);
            } else {
                await addAdditionalDueDiligence(candidatureExternalId, newAdditionalDueDiligence);
            }

            sessionStorage.setItem('addAdditionalDueDiligence', 'true')
            navigate('/candidatura/' + candidatureExternalId);
        } catch (error) {
            console.log(error);
            setError(error);
        }
    }

    if (loading) {
        return <Loading/>;
    }

    if (error && isNotBusinessError(error)) {
        return handleError(error);
    }

    return (
        <SubTemplate>
            <div className='container'>
                <div className='row'>
                    <div className='col-lg-12 mb-5'>
                        <AlertError error={error}/>
                            <AddAdditionalDueDiligenceForm
                                additionalDueDiligence={additionalDueDiligence}
                                setAdditionalDueDiligence={setAdditionalDueDiligence}
                                onSubmit={handleSubmit}
                                candidatureExternalId={candidatureExternalId}
                            />
                    </div>
                </div>
            </div>
        </SubTemplate>
    );
}
